<app-header></app-header>
<router-outlet></router-outlet>    
<app-footer></app-footer>
<app-modal-menu></app-modal-menu>